import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React, { useMemo, useCallback } from 'react';
import { DateTime } from 'luxon';
import usePickerInputValue from './usePickerInputValue.js';
import usePreferenceValue$1 from '../../cinnamon-core/es/components/preferences/usePreferenceValue.js';
import BaseDateTimePicker from './base/BaseDateTimePicker.js';

var _excluded = ["value", "onChange", "timezone", "defaultZone", "minDateTime", "maxDateTime", "slotProps"];
var dateTest = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(.+)?[zZ]?$/;
var dateWarning = "DateTimeInstant only accepts UTC ISO 8601 string value `YYYY-MM-DDTHH:mm:ssZ";

var stringToInstantDateTime = function stringToInstantDateTime(v, timezone, defaultZone) {
  if (!v) return null;

  if (!dateTest.test(v)) {
    console.error(dateWarning);
    return null;
  }

  var dUtc = DateTime.fromISO(v, {
    zone: defaultZone
  });
  var dLocal = dUtc.setZone(timezone);
  return dLocal;
};

var instantDateTimeToString = function instantDateTimeToString(v, timezone) {
  var dLocal = v.setZone(timezone, {
    keepLocalTime: true
  });
  var dUtc = dLocal.toUTC();
  return dUtc.toISO();
};

/**
 * Date and time field for instant dates (point in time that can be globally agreed)
 */
var DateTimeInstant = function DateTimeInstant(_ref) {
  var _bounds$min, _bounds$max;

  var value = _ref.value,
      onChange = _ref.onChange,
      timezone = _ref.timezone,
      defaultZone = _ref.defaultZone,
      minDateTime = _ref.minDateTime,
      maxDateTime = _ref.maxDateTime,
      slotProps = _ref.slotProps,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _usePreferenceValue = usePreferenceValue$1("timezone"),
      _usePreferenceValue2 = _slicedToArray(_usePreferenceValue, 1),
      preferenceTimezone = _usePreferenceValue2[0];

  var tz = timezone || preferenceTimezone;
  var dz = defaultZone || preferenceTimezone;
  var pickerValue = useMemo(function () {
    if (!value) return null;
    return stringToInstantDateTime(value, tz, dz);
  }, [value, tz, dz]);

  var _usePickerInputValue = usePickerInputValue(pickerValue),
      _usePickerInputValue2 = _slicedToArray(_usePickerInputValue, 2),
      inputValue = _usePickerInputValue2[0],
      setInputValue = _usePickerInputValue2[1];

  var pickerChange = useCallback(function (v, _ref2) {
    var validationError = _ref2.validationError;
    setInputValue(v);
    if (!onChange) return;

    if (!v || !v.isValid || !!validationError) {
      onChange(null);
      return;
    }

    onChange(instantDateTimeToString(v, tz));
  }, [onChange, tz]);
  var bounds = useMemo(function () {
    return {
      min: typeof minDateTime === "string" ? stringToInstantDateTime(minDateTime, tz, dz) : minDateTime,
      max: typeof maxDateTime === "string" ? stringToInstantDateTime(maxDateTime, tz, dz) : maxDateTime
    };
  }, [minDateTime, maxDateTime, tz, dz]);
  var textFieldProps = slotProps === null || slotProps === void 0 ? void 0 : slotProps.textField;
  return /*#__PURE__*/React.createElement(BaseDateTimePicker, _extends({}, otherProps, {
    value: inputValue,
    onChange: pickerChange,
    minDateTime: (_bounds$min = bounds.min) !== null && _bounds$min !== void 0 ? _bounds$min : undefined,
    maxDateTime: (_bounds$max = bounds.max) !== null && _bounds$max !== void 0 ? _bounds$max : undefined,
    slotProps: _objectSpread2(_objectSpread2({}, slotProps), {}, {
      textField: _objectSpread2(_objectSpread2({}, textFieldProps), {}, {
        onBlur: function onBlur(e) {
          if (inputValue && !pickerValue) setInputValue(null);
          if (textFieldProps !== null && textFieldProps !== void 0 && textFieldProps.onBlur) textFieldProps.onBlur(e);
        }
      })
    })
  }));
};

DateTimeInstant.propTypes = {
  value: propTypes.oneOfType([propTypes.string, propTypes.oneOf([null])]),
  onChange: propTypes.func,
  timezone: propTypes.oneOfType([propTypes.string, propTypes.any]),
  defaultZone: propTypes.oneOfType([propTypes.string, propTypes.any]),
  minDateTime: propTypes.oneOfType([propTypes.any, propTypes.string, propTypes.oneOf([null])]),
  maxDateTime: propTypes.oneOfType([propTypes.any, propTypes.string, propTypes.oneOf([null])])
};
DateTimeInstant.defaultProps = {
  ampm: false,
  format: "dd/MM/yyyy HH:mm"
};
var DateTimeInstant$1 = DateTimeInstant;

export { DateTimeInstant$1 as default };
